import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IPostVodafoneServices } from '../models/models'

export class PostAuthorizedServicesVodafoneApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/authorizedServicesVodafone/insertVodafoneService',
      requesterInfo,
    })
  }

  public async postAuthorizedServicesMain(request: IPostVodafoneServices): Promise<IPostVodafoneServices> {
    return await this.postAsync<IPostVodafoneServices>(request)
  }
}
